import { type JWT } from '../datatypes'

import axios, { type AxiosInstance } from 'axios'
import { type IBrokerPluginContext } from '@source-digital/sd-app-broker'
import { type IApiEmitter } from '@source-digital/sd-app-client-core'
import { type ExperienceApiEventMap } from './events'

type WithRequired<T, K extends keyof T> = T & Required<Pick<T, K>>

const defaultOptions: WithRequired<ResourceApiOptions, 'userAuthTokenStorageKey'> = {
  userAuthTokenStorageKey: 'sd-app-plugin-experience-api-token'
}

export interface IResourceApiContext {
  brokerPluginCtx: IBrokerPluginContext
  eventEmitter: IApiEmitter<ExperienceApiEventMap>
  apiClient: AxiosInstance
  options: WithRequired<ResourceApiOptions, 'userAuthTokenStorageKey'>
}

export class ResourceApiContext implements IResourceApiContext {
  brokerPluginCtx: IBrokerPluginContext
  apiClient: AxiosInstance
  eventEmitter: IApiEmitter<ExperienceApiEventMap>
  options: WithRequired<ResourceApiOptions, 'userAuthTokenStorageKey'>
  constructor (ctx: IBrokerPluginContext, baseUrl: string, options?: ResourceApiOptions) {
    this.brokerPluginCtx = ctx
    this.apiClient = axios.create({ baseURL: baseUrl })
    this.options = Object.assign({}, defaultOptions, options)
    this.eventEmitter = ctx.eventEmitter
  }
}

export interface ResourceApiOptions {
  userAuthToken?: JWT
  tenant?: string
  userAuthTokenStorageKey?: string
}
export interface BaseRequestOptions extends ResourceApiOptions {
  qs?: boolean
  disableAuth?: boolean
}

export interface ApiOptions {
  currentUser: boolean
}

export abstract class BaseResourceApi {
  #ctx: IResourceApiContext
  constructor (ctx: IResourceApiContext) {
    this.#ctx = ctx
  }

  protected get ctx (): IResourceApiContext {
    return this.#ctx
  }
}
